/**
 * Frontend Observability Logger
 * Maps errors with contexts for clearer stack debugging, eliminating silent failures
 */

const logger = {
  info: (message, ...args) => {
    console.info(`[Info]: ${message}`, ...args);
  },
  warn: (message, ...args) => {
    console.warn(`[Warning]: ${message}`, ...args);
  },
  error: (message, error, context = {}) => {
    console.error(`[Error]: ${message}`, error, context);
    // Future integration point: Send to Sentry, Datadog or Custom Node Backend
  },
  debug: (message, ...args) => {
    if (process.env.NODE_ENV === 'development') {
      console.debug(`[Debug]: ${message}`, ...args);
    }
  }
};

export default logger;
